// export this package's api
import Align from './Align';

export default Align;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/rc-align/es/index.js
// module id = 258
// module chunks = 0